import type { ReactElement } from 'react'
import type { ImageResponseOptions, FigmaImageResponseProps } from './types'

// @ts-ignore
import satori, { init as initSatori } from 'satori/wasm'
import initYoga from 'yoga-wasm-web'
import * as resvg from '@resvg/resvg-wasm'

// @ts-ignore
import resvg_wasm from './resvg.wasm?module'
// @ts-ignore
import yoga_wasm from './yoga.wasm?module'

import render from './og'
import { FigmaImageResponse } from './figma'

const initializedResvg = resvg.initWasm(resvg_wasm)
const initializedYoga = initYoga(yoga_wasm).then((yoga) => initSatori(yoga))
const fallbackFont = fetch(
  new URL('./noto-sans-v27-latin-regular.ttf', import.meta.url)
).then((res) => res.arrayBuffer())

export class ImageResponse extends Response {
  constructor(element: ReactElement, options: ImageResponseOptions = {}) {
    const result = new ReadableStream({
      async start(controller) {
        await initializedYoga
        await initializedResvg
        const fontData = await fallbackFont
        const fonts = [
          {
            name: 'sans serif',
            data: fontData,
            weight: 700,
            style: 'normal',
          },
        ]

        const result = await render(satori, resvg, options, fonts, element)

        controller.enqueue(result)
        controller.close()
      },
    })

    super(result, {
      headers: {
        'content-type': 'image/png',
        'cache-control':
          process.env.NODE_ENV === 'development'
            ? 'no-cache, no-store'
            : 'public, immutable, no-transform, max-age=31536000',
        ...options.headers,
      },
      status: options.status,
      statusText: options.statusText,
    })
  }
}

export const experimental_FigmaImageResponse = async (
  props: FigmaImageResponseProps
) => {
  return FigmaImageResponse({ ...props, Response: ImageResponse })
}

export type EdgeImageResponse = typeof ImageResponse
